import { takeLatest, put, call } from 'redux-saga/effects';
import { httpService } from '@commons';

import {
  BLOQUEAR_CONTA_AGRARE,
  BLOQUEAR_CONTA_AGRARE_PENDING,
  BLOQUEAR_CONTA_AGRARE_SUCCESS,
  BLOQUEAR_CONTA_AGRARE_FAILURE,
  NEW_FILTER_CONTA_AGRARE
} from '../actionTypes';

const bloquearConta = async (id) => {
  return httpService.putApiManager(`/clienteAgrare/bloquear/${id}`, null);
}

function* sagaBloquearContaAgrare(action) {
  yield put({ type: BLOQUEAR_CONTA_AGRARE_PENDING });

  try {
    const registro = yield call(bloquearConta, action.id);
    yield put({ type: BLOQUEAR_CONTA_AGRARE_SUCCESS, registro });

    yield put({ type: NEW_FILTER_CONTA_AGRARE, newFilter: false });

    if (action.resolve) {
      action.resolve();
    }
  } catch (error) {
    yield put({ type: BLOQUEAR_CONTA_AGRARE_FAILURE });

    if (action.resolve) {
      action.resolve();
    }
  }
}

export default function* watchBloquearContaAgrare() {
  yield takeLatest(BLOQUEAR_CONTA_AGRARE, sagaBloquearContaAgrare);
}
